<template>
  <section class="py-12 lg:py-16">
    <div class="mx-auto max-w-6xl px-4">
      <h2 class="landing_h2 mb-10 text-center">
        <Translate translate-key="landing_what_we_offer.title" />
      </h2>
      <ul class="grid list-none grid-cols-1 gap-8 p-0 md:grid-cols-3">
        <!-- Card 1: Over 300 AU tradelines -->
        <li
          class="flex flex-col rounded-xl bg-white px-8 py-10 text-center shadow-[0px_0px_35px_rgba(0,0,0,0.08)]"
        >
          <h3 class="mb-6 text-left text-base font-black text-gray-900">
            <Translate translate-key="landing_what_we_offer.subtitle" />
          </h3>
          <div class="mb-6 flex h-[93px] items-center justify-center">
            <NuxtImg
              src="/landing/over-250-authorized-user-tradelines.png"
              :alt="t('landing_what_we_offer.image_1_alt')"
              format="webp"
              class="h-[93px] w-auto object-contain"
              loading="lazy"
            />
          </div>
          <p
            class="innerContent mb-6 flex-1 text-left text-gray-700"
            v-html="t('landing_what_we_offer.text')"
          />
          <a
            :href="linkHref('/tradelines-for-sale?limit=50&offset=0')"
            class="inline-flex shrink-0 justify-center"
          >
            <Button variant="landing1" size="lg">
              <Translate translate-key="landing_what_we_offer.browse_tradelines" />
            </Button>
          </a>
        </li>

        <!-- Card 2: 60 days minimum -->
        <li
          class="flex flex-col rounded-xl bg-white px-8 py-10 text-center shadow-[0px_0px_35px_rgba(0,0,0,0.08)]"
        >
          <h3 class="mb-6 text-left text-base font-black text-gray-900">
            <Translate translate-key="landing_what_we_offer.subtitle_2" />
          </h3>
          <div class="mb-6 flex h-[93px] items-center justify-center gap-1">
            <NuxtImg
              src="/landing/authorized-user-tradelines-for-60-days-minimum.png"
              :alt="t('landing_what_we_offer.image_2_alt')"
              format="webp"
              class="h-[93px] w-auto object-contain"
              loading="lazy"
            />
            <NuxtImg
              src="/landing/authorized-user-tradelines-for-60-days-minimum.png"
              :alt="t('landing_what_we_offer.image_3_alt')"
              format="webp"
              class="h-[93px] w-auto object-contain"
              loading="lazy"
            />
          </div>
          <p
            class="innerContent flex-1 text-left text-gray-700"
            v-html="t('landing_what_we_offer.text_2')"
          />
        </li>

        <!-- Card 3: Guarantee -->
        <li
          class="flex flex-col rounded-xl bg-white px-8 py-10 text-center shadow-[0px_0px_35px_rgba(0,0,0,0.08)]"
        >
          <h3 class="mb-6 text-left text-base font-black text-gray-900">
            <Translate translate-key="landing_what_we_offer.subtitle_3" />
          </h3>
          <div class="mb-6 flex h-[93px] items-center justify-center">
            <NuxtImg
              src="/landing/our-tradeline-guarantee.png"
              :alt="t('landing_what_we_offer.image_4_alt')"
              format="webp"
              class="h-[93px] w-auto object-contain"
              loading="lazy"
            />
          </div>
          <p
            class="innerContent flex-1 text-left text-gray-700"
            v-html="t('landing_what_we_offer.text_3')"
          />
        </li>
      </ul>

      <h3 class="mt-16 mb-4 text-center text-2xl font-black text-black md:text-4xl">
        <Translate translate-key="landing_what_we_offer.subtitle_4" />
      </h3>
      <h3 class="mb-12 text-center text-xl font-black text-black md:text-2xl">
        <Translate translate-key="landing_what_we_offer.reach_out_today" />
      </h3>

      <div v-if="showBrokerCta" class="flex justify-center">
        <Button
          as="a"
          :href="linkHref('/signup?type=broker')"
          variant="landing1"
          size="xl"
          class="pulseBtn"
        >
          <Translate translate-key="landing_what_we_offer.pulse_btn" />
        </Button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { Button } from "~/shared/components/ui/button";
import { useI18n } from "vue-i18n";

defineProps<{
  /** Show "Become a Broker Now" CTA (e.g. on tradeline-brokerage page) */
  showBrokerCta?: boolean;
}>();

const { t } = useI18n();
const { linkHref } = useNativeRouteLink();
</script>

<style scoped>
.innerContent :deep(a) {
  @apply text-teal-600 underline;
}
.innerContent :deep(strong) {
  @apply font-semibold;
}

/* Pulsing ring (from Nuxt bridge PulseButton) */
.pulseBtn {
  animation: pulseBtn 2s infinite;
}

@keyframes pulseBtn {
  0% {
    box-shadow: 0 0 0 0 rgb(220 38 38 / 1);
  }
  70% {
    box-shadow: 0 0 0 10px rgb(220 38 38 / 0);
  }
  100% {
    box-shadow: 0 0 0 50px rgb(220 38 38 / 0);
  }
}
</style>
